export default {
      id: "red-dot-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#red-dot",
      toString: function () {
        return this.url;
      }
    }